module.exports = __webpack_public_path__ + "img/portugal-cervical-cancer-female.39ff3b01.png";